import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { restoreInterfaceModeOnBoot } from '../../helpers/apply-interface-mode';

/**
 * Runs once on application launch when the user lands on "/" to restore interface mode.
 * Does not affect deep links, bookmarks, or later in-app navigation to "/".
 */
const InterfaceModeBoot = () => {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const userInfo = useSelector((state) => state.auth.userInfo);
    const hasRunRef = useRef(false);

    useEffect(() => {
        if (hasRunRef.current) {
            return;
        }

        hasRunRef.current = true;

        if (location.pathname.startsWith('/admin')) {
            return;
        }

        restoreInterfaceModeOnBoot({
            pathname: location.pathname,
            dispatch,
            history,
            authState: { isLoggedIn, userInfo },
        });
    }, [dispatch, history, isLoggedIn, location.pathname, userInfo]);

    return null;
};

export default InterfaceModeBoot;
